import { formatUsd } from "@platform/formatting-utils/formatters";

/**
 * Hover lines for a premium that sits beside its current one. `renewal` is what the cell
 * shows (revised renewal when revised rates exist, else renewal); `priorRenewal` is the
 * renewal premium it supersedes, present only when revised renewal is what is shown.
 */
export const renewalTooltipLines = (
  current: number,
  renewal: number,
  priorRenewal?: number,
): string[] =>
  priorRenewal === undefined
    ? [`Current: ${formatUsd(current, 2)}`, `Renewal: ${formatUsd(renewal, 2)}`]
    : [
        `Current: ${formatUsd(current, 2)}`,
        `Renewal: ${formatUsd(priorRenewal, 2)}`,
        `Revised Renewal: ${formatUsd(renewal, 2)}`,
      ];
